import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import LinearProgress from "@material-ui/core/LinearProgress";

import { i18n } from "../../translate/i18n";
import useReportsData from "./useReportsData";
import FiltersBar from "./FiltersBar";
import SummaryTab from "./SummaryTab";
import PendingTab from "./PendingTab";
import TeamTab from "./TeamTab";
import ChannelsTab from "./ChannelsTab";
import TagsTab from "./TagsTab";
import CsatTab from "./CsatTab";
import KanbanTab from "./KanbanTab";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px 24px 32px",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    minHeight: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("xs")]: { padding: "16px 12px 24px" },
  },
  title: { margin: 0, fontSize: 24, fontWeight: 700, color: theme.palette.text.primary },
  subtitle: { margin: "4px 0 0", fontSize: 14, color: theme.palette.text.secondary },
  tabs: { borderBottom: `1px solid ${theme.palette.divider}`, minHeight: 40 },
  tab: { textTransform: "none", fontWeight: 600, minHeight: 40, minWidth: 90 },
}));

/**
 * «Informes» (doc 0447): sustituye a «Métricas». Datos de la empresa del usuario,
 * permiso `reports:ver` (administradores y supervisores).
 */
const Reports = () => {
  const classes = useStyles();
  const { filters, setPreset, setFilter, data, loading } = useReportsData();
  const [tab, setTab] = useState("summary");
  const pendingCount = (data.pending || []).length;

  return (
    <div className={classes.root}>
      <header>
        <h1 className={classes.title}>{i18n.t("reports.title")}</h1>
        <p className={classes.subtitle}>{i18n.t("reports.subtitle")}</p>
      </header>

      <FiltersBar filters={filters} setPreset={setPreset} setFilter={setFilter} />

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        className={classes.tabs}
      >
        <Tab value="summary" label={i18n.t("reports.tabs.summary")} className={classes.tab} />
        <Tab
          value="pending"
          label={`${i18n.t("reports.tabs.pending")}${pendingCount ? ` (${pendingCount})` : ""}`}
          className={classes.tab}
        />
        <Tab value="team" label={i18n.t("reports.tabs.team")} className={classes.tab} />
        <Tab value="channels" label={i18n.t("reports.tabs.channels")} className={classes.tab} />
        <Tab value="csat" label={i18n.t("reports.tabs.csat")} className={classes.tab} />
        <Tab value="tags" label={i18n.t("reports.tabs.tags")} className={classes.tab} />
        <Tab value="kanban" label={i18n.t("reports.tabs.kanban")} className={classes.tab} />
      </Tabs>

      {loading && <LinearProgress />}

      {tab === "summary" && <SummaryTab data={data} filters={filters} />}
      {tab === "pending" && <PendingTab items={data.pending || []} />}
      {tab === "team" && <TeamTab data={data} />}
      {tab === "channels" && <ChannelsTab data={data} />}
      {tab === "csat" && <CsatTab data={data} />}
      {tab === "tags" && <TagsTab data={data} />}
      {tab === "kanban" && <KanbanTab data={data} />}
    </div>
  );
};

export default Reports;
